import { defaultDirection, defaultColor, themeSelectedColorStorageKey, themeRadiusStorageKey, localeOptions, defaultLocale } from '../constants/config'
import { clearSessionPolicyAgreed } from './policyAgreement'



export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key]
    const B = b[key]
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1
    } else {
      return -1
    }
  })
  return array
}

export const getDateWithFormat = () => {
  const today = new Date()
  let dd = today.getDate()
  let mm = today.getMonth() + 1 // January is 0!

  const yyyy = today.getFullYear()
  if (dd < 10) {
    dd = '0' + dd
  }
  if (mm < 10) {
    mm = '0' + mm
  }
  return dd + '.' + mm + '.' + yyyy
}

export const getCurrentTime = () => {
  const now = new Date()
  return now.getHours() + ':' + now.getMinutes()
}

export const ThemeColors = () => { 
  return { 
  }
}

export const getDirection = () => {
  let direction = defaultDirection
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction')
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl'
  }
}

export const setDirection = localValue => {
  let direction = 'ltr'
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue
  }
  localStorage.setItem('direction', direction)
}


export const getThemeColor = () => {
  let color = defaultColor;
  try {
    if (localStorage.getItem(themeSelectedColorStorageKey)) {
      color = localStorage.getItem(themeSelectedColorStorageKey) || defaultColor;
    }
  } catch (error) {
    console.log(">>>> src/utils/index.js : getThemeColor -> error", error)
    color = defaultColor;
  }
  return color;
}

export const setThemeColor = (color) => {
  try {
    localStorage.setItem(themeSelectedColorStorageKey, color);
  } catch (error) {
    console.log(">>>> src/utils/index.js : setThemeColor -> error", error)
  }
}

export const getThemeRadius = () => {
  let radius = "rounded";
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      radius = localStorage.getItem(themeRadiusStorageKey) || "rounded";
    }
  } catch (error) {
    console.log(">>>> src/utils/index.js : getThemeRadius -> error", error)
    radius = "rounded";
  }
  return radius;
}

export const setThemeRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius);
  } catch (error) {
    console.log(">>>> src/utils/index.js : setThemeRadius -> error", error)
  }
}

export const getCurrentLanguage = () => {
  let locale = defaultLocale;
  try {
    if (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) { locale = localStorage.getItem('currentLanguage'); }
  } catch (error) {
    console.log(">>>> src/utils/index.js : getCurrentLanguage -> error", error)
    locale = defaultLocale;
  }
  return locale;
}

export const setCurrentLanguage = (lang) => {
  try {
    localStorage.setItem('currentLanguage', lang)
  } catch (error) {
    console.log(">>>> src/utils/index.js : setCurrentLanguage -> error", error)
  }
}

export const getCurrentUser = () => {
  let user = null;
  try {
 
    user = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null;
  } catch (error) {
    console.log(">>>> src/utils/index.js : getCurrentUser -> error", error)
    user = null;
  }
  return user;
}

export const setCurrentUser = (user) => {
  try {
    if (user) {
      
      localStorage.setItem('user', JSON.stringify(user))
    } else {
      localStorage.removeItem('user');
    }
  } catch (error) {
    console.log(">>>> src/utils/index.js : setCurrentUser -> error", error)
  }
}

export const getSignInRoute = () => {
  let pt = localStorage.getItem('pt');

  if (!pt) {
    const host = window.location.host;
    if (host === 'localhost:8080' || host === 'ec5.empoweredconsumerism.com' || host === 'ec5test.empoweredconsumerism.com') {
      pt = 'ecp';
    } else if (host === 'ng.aimglobalinc.com' || host === 'dtc.aimglobalinc.com' || host === 'my.economydriver.com' || host === 'my.economydesigner3.com') {
      pt = 'edp';
    } else if (host === 'my.bibosuperapp.com') {
      pt = 'bibo';
    } else if (host === 'my.iglow247.com') {
      pt = 'iglow';
    } else if (host === 'my.ecrowdcommerce.com') {
      pt = 'ecc';
    } else if (host === 'pcp.empoweredconsumerism.com') {
      pt = 'pcp';
    } else if (host === 'my.orbixvictus.com') {
      pt = 'ovi';
    }
  }

  if (pt === 'ecp') return '/sign-in-ec';
  if (pt === 'edp') return '/sign-in-ed';
  if (pt === 'bibo') return '/sign-in-bibo';
  if (pt === 'iglow') return '/sign-in-iglow';
  if (pt === 'ecc') return '/sign-in-ecc';
  if (pt === 'pcp') return '/sign-in-pcp';
  return '/sign-in';
}

export const logoutUser = (redirect = true) => {
  clearSessionPolicyAgreed();
  localStorage.removeItem('ecmtctoken');
  localStorage.removeItem('ecmtcrefresh');
  localStorage.removeItem('user');
  localStorage.removeItem('ec_current_usid');
  localStorage.removeItem('override_cifid');

  if (redirect) {
    const signInRoute = getSignInRoute();
    window.location.replace(`${window.location.origin}/#${signInRoute}`);
  }
}
